module.exports = __webpack_public_path__ + "img/daily.f488d8ff.svg";